let Init = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.select2();
        this.datepicker();
        this.tooltip();
        this.clickable();
    },

    select2() {
        $.fn.select2.defaults.set('theme', 'bootstrap4');
        $('.select2').select2();

        // on first focus (bubbles up to document), open the menu
        $(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
            $(this).closest(".select2-container").siblings('select:enabled').select2('open');
        });

        // steal focus during close - only capture once and stop propogation
        $('select.select2').on('select2:closing', function (e) {
            $(e.target).data("select2").$selection.one('focus focusin', function (e) {
                e.stopPropagation();
            });
        });
    },

    datepicker() {
        $('.datepicker').datepicker({
            format: 'mm/dd/yyyy',
            orientation: 'bottom'
        });

        $('.monthyearpicker').datepicker({
            format: 'mm/yyyy',
            orientation: 'bottom',
            viewMode: "months",
            minViewMode: "months",
            endDate: '+0d',
            autoclose: true,
        });
    },

    tooltip() {
        $('[data-toggle="tooltip"]').tooltip()
    },

    clickable() {
        $(document).on('click', '[data-href]', function () {
            const href = $(this).data('href');

            if (href.length) {
                window.open(href, '_blank');
                // window.location.assign(href);
            }
        });
    },
};


$().ready(() => {
    window.Init = Init;
    window.Init.init();
});
